module.exports = __webpack_public_path__ + "img/email.d41c495f.svg";